import CommonUiModel from "../common/commonUiModel";

const HistoryModel = new CommonUiModel({
    title: "SecurityModLogRecordDetails",
    linkColumn: "ColumnName",
    idProperty: 'ModDetailId',
    gridTitle: 'Revision History',
    readOnly: true,
    preferenceId: 'SecurityModLogRecordDetails',
    module: null,
    defaultSort: "ModDetailId desc",
    addCreatedOnColumn: false,
    addCreatedByColumn: false,
    columns: [
        { field: 'PrimaryKey', label: 'Primary Key', type: 'number' },
        { field: 'DisplayField', label: 'Master Modified' },
        { field: 'TableName', label: 'Table Name' },
        { field: 'ActionTypeId', label: 'Type', type: 'select', width: 200, lookup: 'Type' },
        { field: 'ColumnName', label: 'Field Name' },
        { field: 'FinalOldValue', label: 'Old Value', filterable: false, sortable: false },
        { field: 'FinalNewValue', label: 'New Value', filterable: false, sortable: false }
    ]
});

export default HistoryModel;